var swapIconPath = "M500,28C626,28,741,79,823,162L958,28V428H557L742,244C680,182,595,142,500,142C310,142,156,296,156,486H42C42,233,247,28,500,28zM500,972C374,972,259,921,177,838L42,972V572H443L258,756C320,818,406,858,500,858C690,858,844,704,844,514H958C958,767,753,972,500,972z";

export { swapIconPath as default };
